import { render, staticRenderFns } from "./AdCta.vue?vue&type=template&id=f0555ad0&scoped=true"
import script from "./AdCta.vue?vue&type=script&lang=js"
export * from "./AdCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0555ad0",
  null
  
)

export default component.exports